// extracted by mini-css-extract-plugin
export var blogBreadcrumbs = "blogPage-module--blogBreadcrumbs--a0807";
export var blogHomeContent = "blogPage-module--blogHomeContent--131a2";